
import React from 'react'
import { Col, Row } from 'antd';
import { Typography } from 'antd';
import { LogoWidget } from '../playground/widgets';
import Grid from 'antd/lib/card/Grid';
import loginCover from '../resources/back.jpg';

export function LoginInfoView() {
  // const { t } = useI18n('loginInfoView.view')
  return (
    <div className='MuiGrid-grid MuiGrid-item loginContainer__column loginContainer__column--right'>
      <div className='login--animation'>

        <div className='login_image '>
          <img
            className='fade-in'
            //src='/loginPageShape1.svg'
            src={loginCover}
            alt=''
          />
        </div>

      </div>
    </div>
  )
}
